import { AlignmentType, BorderStyle, Paragraph, Table, TableCell, TableLayoutType, TableRow, TextRun, VerticalAlign, WidthType, ShadingType } from "docx";

export const tools = new Table({
    width: { size: 100, type: WidthType.PERCENTAGE },
    alignment: AlignmentType.CENTER,
    layout: TableLayoutType.FIXED,
    spacing: { before: 600 },
    borders: {
        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
    },
    rows: [
        new TableRow({
            children: [
                new TableCell({
                    width: { size: 9, type: WidthType.PERCENTAGE },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            indent: { left: 50, right: 50 },
                            spacing: { before: 80 },
                            children: [
                                new TextRun({
                                    text: "Sl No.",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    italics: false,
                                    bold: true
                                })
                            ]
                        })],

                    shading: { type: ShadingType.SOLID, color: "D9E2F3" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),

                new TableCell({
                    width: { size: 33, type: WidthType.PERCENTAGE },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            indent: { left: 50, right: 50 },
                            spacing: { before: 80 },
                            children: [
                                new TextRun({
                                    text: "Name of Tool/Software used",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    italics: false,
                                    bold: true
                                })
                            ]
                        })],

                    shading: { type: ShadingType.SOLID, color: "D9E2F3" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),

                new TableCell({
                    width: { size: 24, type: WidthType.PERCENTAGE },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            spacing: { before: 80 },
                            indent: { left: 50, right: 50 },
                            children: [
                                new TextRun({
                                    text: "Version of the tool/ Software used",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    italics: false,
                                    bold: true
                                })
                            ]
                        })],

                    shading: { type: ShadingType.SOLID, color: "D9E2F3" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),
                new TableCell({
                    width: { size: 24, type: WidthType.PERCENTAGE },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            spacing: { before: 80 },
                            indent: { left: 50, right: 50 },
                            children: [
                                new TextRun({
                                    text: "Open Source/Licensed",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    italics: false,
                                    bold: true
                                })
                            ]
                        })],

                    shading: { type: ShadingType.SOLID, color: "D9E2F3" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),

            ]
        }),

        new TableRow({
            children: [
                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            spacing: { before: 80 },
                            indent: { left: 50, right: 50 },
                            children: [
                                new TextRun({
                                    text: "1",
                                    font: "Arial",
                                    size: 22,
                                    color: "000000",
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),

                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            indent: { left: 50, right: 50 },
                            spacing: { before: 80, after: 80 },
                            children: [
                                new TextRun({
                                    text: "SonarQube",
                                    font: "Arial",
                                    size: 22,
                                    color: "000000",
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),

                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            spacing: { before: 80, after: 80 },
                            indent: { left: 50, right: 50 },
                            children: [
                                new TextRun({
                                    text: "25.3.0.104237",
                                    font: "Arial",
                                    size: 22,
                                    color: "000000",
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),
                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            spacing: { before: 80 },
                            indent: { left: 50, right: 50 },
                            children: [
                                new TextRun({
                                    text: "Licensed",
                                    font: "Arial",
                                    size: 22,
                                    color: "000000",
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),

            ]
        }),

        new TableRow({
            children: [
                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            spacing: { before: 80 },
                            indent: { left: 50, right: 50 },
                            children: [
                                new TextRun({
                                    text: "2",
                                    font: "Arial",
                                    size: 22,
                                    color: "000000",
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),

                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            indent: { left: 50, right: 50 },
                            spacing: { before: 80, after: 80 },
                            children: [
                                new TextRun({
                                    text: "Insider",
                                    font: "Arial",
                                    size: 22,
                                    color: "000000",
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),

                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            spacing: { before: 80, after: 80 },
                            indent: { left: 50, right: 50 },
                            children: [
                                new TextRun({
                                    text: "NA",
                                    font: "Arial",
                                    size: 22,
                                    color: "000000",
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),
                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            spacing: { before: 80 },
                            indent: { left: 50, right: 50 },
                            children: [
                                new TextRun({
                                    text: "Open Source",
                                    font: "Arial",
                                    size: 22,
                                    color: "000000",
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),
            ]
        }),
        new TableRow({
            children: [
                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            spacing: { before: 80 },
                            indent: { left: 50, right: 50 },
                            children: [
                                new TextRun({
                                    text: "3",
                                    font: "Arial",
                                    size: 22,
                                    color: "000000",
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),

                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            indent: { left: 50, right: 50 },
                            spacing: { before: 80, after: 80 },
                            children: [
                                new TextRun({
                                    text: "Grep",
                                    font: "Arial",
                                    size: 22,
                                    color: "000000",
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),

                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            spacing: { before: 80, after: 80 },
                            indent: { left: 50, right: 50 },
                            children: [
                                new TextRun({
                                    text: "3.12",
                                    font: "Arial",
                                    size: 22,
                                    color: "000000",
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),
                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            spacing: { before: 80 },
                            indent: { left: 50, right: 50 },
                            children: [
                                new TextRun({
                                    text: "Open Source",
                                    font: "Arial",
                                    size: 22,
                                    color: "000000",
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),
            ]
        }),

        new TableRow({
            children: [
                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            spacing: { before: 80 },
                            indent: { left: 50, right: 50 },
                            children: [
                                new TextRun({
                                    text: "4",
                                    font: "Arial",
                                    size: 22,
                                    color: "000000",
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),

                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            indent: { left: 50, right: 50 },
                            spacing: { before: 80, after: 80 },
                            children: [
                                new TextRun({
                                    text: "Snyk",
                                    font: "Arial",
                                    size: 22,
                                    color: "000000",
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),

                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            spacing: { before: 80, after: 80 },
                            indent: { left: 50, right: 50 },
                            children: [
                                new TextRun({
                                    text: "1.1296.1",
                                    font: "Arial",
                                    size: 22,
                                    color: "000000",
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),
                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            spacing: { before: 80 },
                            indent: { left: 50, right: 50 },
                            children: [
                                new TextRun({
                                    text: "Open Source",
                                    font: "Arial",
                                    size: 22,
                                    color: "000000",
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),
            ]
        }),

        new TableRow({
            children: [
                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            spacing: { before: 80 },
                            indent: { left: 50, right: 50 },
                            children: [
                                new TextRun({
                                    text: "5",
                                    font: "Arial",
                                    size: 22,
                                    color: "000000",
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),

                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            indent: { left: 50, right: 50 },
                            spacing: { before: 80, after: 80 },
                            children: [
                                new TextRun({
                                    text: "Semgrep",
                                    font: "Arial",
                                    size: 22,
                                    color: "000000",
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),

                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            spacing: { before: 80, after: 80 },
                            indent: { left: 50, right: 50 },
                            children: [
                                new TextRun({
                                    text: "2.6.0",
                                    font: "Arial",
                                    size: 22,
                                    color: "000000",
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),
                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            spacing: { before: 80 },
                            indent: { left: 50, right: 50 },
                            children: [
                                new TextRun({
                                    text: "Open Source",
                                    font: "Arial",
                                    size: 22,
                                    color: "000000",
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),
            ]
        }),

    ]
})